import { Component } from 'macguffin'
import { Loader } from "pixi.js"
const { resources } = Loader.shared

const textureCache = {}
function getTexture(assetName) {
    if (textureCache[assetName]) {
        return textureCache[assetName]
    }

    if (!resources[assetName]) {
        return
    }

    const texture = resources[assetName].texture
    textureCache[assetName] = texture
    return texture
}

export default class BackroundImage extends Component {
    render() {
        const { props } = this
        const { className, assetName, style, children, onClick } = props

        const texture = getTexture(assetName)
        if (texture) {
            const url = texture.baseTexture.resource.url
            const frame = texture._frame

            const defaultStyle = {
                position: "absolute",
                backgroundImage: `url("${url}")`,
                backgroundSize: "contain",
                backgroundPosition: "top left",
                backgroundRepeat: "no-repeat"
            }

            return <div className={className} style={{...defaultStyle, ...style}} children={children} onClick={onClick}/>
        } else {
            const defaultStyle = {
                position: "absolute"
            }

            return <div className={className} style={{...defaultStyle, ...style}} children={children} onClick={onClick}/>
        }
    }
}
